import React from 'react'
import { NavLink, Outlet, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Button } from '@/components/ui'

const navItem = 'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100'
const navItemActive = 'bg-brand-50 text-brand-700'

export default function AdminLayout() {
  const { profile, signOut } = useAuth()
  const { eventId } = useParams<{ eventId: string }>()
  const location = useLocation()

  const eventNav = eventId
    ? [
        { to: `/admin/events/${eventId}`, label: 'Dashboard', end: true },
        { to: `/admin/events/${eventId}/companies`, label: 'Companies' },
        { to: `/admin/events/${eventId}/hotels`, label: 'Hotels' },
        { to: `/admin/events/${eventId}/room-types`, label: 'Room Types' },
        { to: `/admin/events/${eventId}/rooming-list`, label: 'Rooming List' },
        { to: `/admin/events/${eventId}/import-export`, label: 'Import / Export' },
        { to: `/admin/events/${eventId}/activity`, label: 'Activity' },
        { to: `/admin/events/${eventId}/settings`, label: 'Settings' },
      ]
    : []

  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="flex w-60 flex-col border-r border-slate-200 bg-white">
        <div className="border-b border-slate-100 px-4 py-4">
          <NavLink to="/admin/events" className="text-sm font-semibold text-slate-900">
            Rooming List
          </NavLink>
        </div>
        <nav className="flex-1 space-y-0.5 overflow-y-auto px-2 py-3">
          <NavLink to="/admin/events" end className={({ isActive }) => `${navItem} ${isActive && location.pathname === '/admin/events' ? navItemActive : ''}`}>
            All Events
          </NavLink>
          {eventNav.length > 0 && (
            <>
              <div className="mt-4 px-3 text-xs font-semibold uppercase tracking-wide text-slate-400">This Event</div>
              {eventNav.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ''}`}>
                  {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>
        <div className="border-t border-slate-100 px-4 py-3">
          <div className="mb-2 text-xs text-slate-500">
            <div className="font-medium text-slate-700">{profile?.full_name || 'Admin'}</div>
            <div className="capitalize">{profile?.role?.replace('_', ' ')}</div>
          </div>
          <Button size="sm" variant="ghost" className="w-full justify-start" onClick={() => signOut()}>
            Log out
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
